export default import.meta.ROLLDOWN_FILE_URL_qMHHG2JdhL5XtnQaGmuqPA